export default {
  // Add app specific user parameters
}
